export const GET_SOCIAL_LINKS = "GET_SOCIAL_LINKS";
export const GET_SOCIAL_LINKS_SUCCESS = "GET_SOCIAL_LINKS_SUCCESS";
export const GET_SOCIAL_LINKS_FAILURE = "GET_SOCIAL_LINKS_FAILURE";

// ===================================================
// ===================================================

export const GET_SOCIAL_LINK = "GET_SOCIAL_LINK";
export const GET_SOCIAL_LINK_SUCCESS = "GET_SOCIAL_LINK_SUCCESS";
export const GET_SOCIAL_LINK_FAILURE = "GET_SOCIAL_LINK_FAILURE";

// ===================================================
// ===================================================

export const CREATE_SOCIAL_LINK = "CREATE_SOCIAL_LINK";
export const CREATE_SOCIAL_LINK_SUCCESS = "CREATE_SOCIAL_LINK_SUCCESS";
export const CREATE_SOCIAL_LINK_FAILURE = "CREATE_SOCIAL_LINK_FAILURE";

// ===================================================
// ===================================================

export const UPDATE_SOCIAL_LINK = "UPDATE_SOCIAL_LINK";
export const UPDATE_SOCIAL_LINK_SUCCESS = "UPDATE_SOCIAL_LINK_SUCCESS";
export const UPDATE_SOCIAL_LINK_FAILURE = "UPDATE_SOCIAL_LINK_FAILURE";

// ===================================================
// ===================================================

export const DELETE_SOCIAL_LINK = "DELETE_SOCIAL_LINK";
export const DELETE_SOCIAL_LINK_SUCCESS = "DELETE_SOCIAL_LINK_SUCCESS";
export const DELETE_SOCIAL_LINK_FAILURE = "DELETE_SOCIAL_LINK_FAILURE";

// ===================================================
// ===================================================
